import { useEffect } from 'react';
import type { Room } from 'livekit-client';

export function usePageLeaveDisconnect(room: Room) {
    useEffect(() => {
        const disconnect = () => void room.disconnect();
        globalThis.addEventListener('pagehide', disconnect);
        return () => {
            globalThis.removeEventListener('pagehide', disconnect);
            void room.disconnect();
        };
    }, [room]);
}
